/*
  Params:
  Object Model as props:
  {
  prefix: String,
  constants: Array<string>
  }
*/
export default function actionTypes({ prefix, constants }) {
  return Object.freeze(
    constants.reduce(
      (obj, constant) => ({
        ...obj,
        [constant]: `${prefix}/${constant}`,
      }),
      {},
    ),
  );
}
